import {
  Agency,
  AgencyBalanceInterface,
  AgencyFundInterface,
  Announcement,
  BalanceInterface,
  Client,
  CreateAnnouncementDTO,
  CreateInvoiceDTO,
  Invoice,
  UserPaymentStatus,
} from './agency.interface'
import { axiosApi } from '@/axios'
import { AxiosResponse } from 'axios'
import { Paginator, Params, Body } from '@/utils/interfaces'
import { createOrUpdate } from '@/utils/functions'
import { Transaction } from '@/utils/interfaces/topup.interface'
import { ApiController } from '@/utils/classes/ApiController'
import { DeliveryCurrenciesEnum } from '~/utils/interfaces/remittance.interface'

export const getAgencyById = (uuid: string): Promise<AxiosResponse<Agency>> =>
  axiosApi.get(`/agencies/${uuid}/`)

export const getAgencies = (
  params?: Params,
): Promise<AxiosResponse<Paginator<Agency>>> =>
  axiosApi.get('/agencies/', {
    params,
  })

export function createAgency(
  body: Body,
  fileField?: string,
): Promise<AxiosResponse<Agency>> {
  return createOrUpdate('/agencies/', body, fileField)
}

export const getTransactions = (
  params?: Params,
): Promise<AxiosResponse<Paginator<Transaction>>> =>
  axiosApi.get('/transactions/', { params })

export const createClient = (body: Body): Promise<AxiosResponse<Client>> =>
  createOrUpdate(
    '/clients/',
    { ...body, credit_card: body.credit_card.split(' ').join('') },
    'image',
  )

export const deleteClient = (uuid: string) =>
  axiosApi.delete(`/clients/${uuid}/`)

export const getClients = (
  params?: Params,
): Promise<AxiosResponse<Paginator<Client>>> =>
  axiosApi.get('/clients/', { params })

export const agencyPay = (body: Body) => axiosApi.post('/agency-payment/', body)

export const agencyCharge = (body: Body) =>
  axiosApi.post('/agency-charge/', body)

export const getUsersPayment = (params?: Params) =>
  axiosApi.get('/user-payments/', { params })

export const updateUsersPayment = (
  uuid: string,
  status: UserPaymentStatus,
  description: string,
  convert_to_credit: boolean,
  convert_to_balance: boolean,
  remittance_currency: null | DeliveryCurrenciesEnum,
) =>
  axiosApi.patch(`/user-payments/${uuid}/`, {
    status,
    snippet: description,
    convert_to_credit,
    convert_to_balance,
    remittance_currency,
  })

export const assignUsersPayment = (uuid: string, agent: string) =>
  axiosApi.patch(`/user-payments/${uuid}/`, { agent })

export const creditFunds = (body: {
  agent: string
  product_amount: string
  count: string
  description: string
}) => axiosApi.post('/funds/credit/', body)

export const extractFunds = (body: {
  agent: string
  amount: string
  description: string
}) => axiosApi.post('/funds/extract/', body)

export const depositFunds = (body: {
  agent: string
  amount: string
  description: string
}) => axiosApi.post('/funds/deposit/', body)

export const balanceTransactionsController = new ApiController<
  BalanceInterface,
  any
>('/transactions/balance/')

export const agencyFundTransactionsController = new ApiController<
  AgencyFundInterface,
  any
>('/transactions/funds/')

export const agencyBalanceTransactionsController = new ApiController<
  AgencyBalanceInterface,
  any
>('/billtransactions/balance/')

export const announcementController = new ApiController<
  Announcement,
  CreateAnnouncementDTO
>('/banners/')

export const invoiceController = new ApiController<Invoice, CreateInvoiceDTO>(
  '/invoices/',
)

export const getInvoicePdf = (invoiceUuid: string) =>
  axiosApi.get(`/invoice-pdf/${invoiceUuid}/`)

export const sendInvoicePdf = (invoiceUuid: string) =>
  axiosApi.patch(`/invoice-send/${invoiceUuid}/`)

export const getInvoiceXls = (params?: Params) =>
  axiosApi.get('/invoice-xls/', {
    params,
    responseType: 'arraybuffer',
  })
